import { PropsWithChildren } from "react";

export const IconWrapper = ({ children }: PropsWithChildren) => (
  <i
    style={{
      width: "19px",
      height: "19px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    {children}
  </i>
);